import React, { useState, useEffect } from "react";
import {
  AppProvider,
  LegacyCard,
  TextField,
  Select,
  Checkbox,
  ChoiceList,
  InlineGrid,
  Spinner,
  Button,
  Icon,
} from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import { jwtDecode } from "jwt-decode";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@shopify/polaris-icons";
import JacketMeasurements from "./Customers/JacketMeasurements";
import PantMeasurements from "./Customers/PantMeasurements";
import ShortPantMeasurements from "./Customers/ShortPantMeasurements";
import VestMeasurements from "./Customers/VestMeasurements";
import ShirtMeasurements from "./Customers/ShirtMeasurements";
import JeanMeasurements from "./Customers/JeanMeasurements";
import MenOvercoatMeasurements from "./Customers/MenOvercoatMeasurements";
import WomenJacketMeasurements from './Customers/WomenJacketMeasurements';
import WomenPantMeasurements from './Customers/WomenPantMeasurements';
import WomenShortMeasurements from './Customers/WomenShortMeasurements';
import WomenVestMeasurements from './Customers/WomenVestMeasurements';
import WomenShirtMeasurements from './Customers/WomenShirtMeasurements';
import WomenOvercoatMeasurements from './Customers/WomenOvercoatMeasurements';
import WomenJeanMeasurements from './Customers/WomenJeanMeasurements';
import PalmJacketMeasurements from './Customers/PalmJacketMeasurements';

export default function NewClientEntry() {
  const baseUrl = process.env.REACT_APP_API_URL;
  const { id } = useParams();
  const location = useLocation();
  const customer = location.state?.customer;
  const viewMode = location.state?.viewMode === true;
  const JsonCustomer = customer.json;

  const [form, setForm] = useState({
    name: "",
    gender: "Male",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "Alabama",
    pincode: "",
    country: "United States",
    measurements: {
      jacket: true,
      pant: false,
      shortPant: false,
      vest: false,
      shirt: false,
      jean: false,
      menOvercoat: false,
      womenJacket: false,
      womenPant: false,
      womenShort: false,
      womenVest: false,
      womenShirt: false,
      womenOvercoat: false,
      womenJean: false,
      palmJacket: false,
    },
    jacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
      firstButtonPlacement: "",
    },
    pant: {
      waist: "",
      seat: "",
      outseam: "",
      knee: "",
      bottom: "",
    },
    shortPant: {
      waist: "",
      seat: "",
      shortOutseam: "",
      shortBottom: "",
    },
    vest: {
      chest: "",
      stomach: "",
      backLength: "",
      frontLength: "",
      firstButtonPlacement: ""
    },
    shirt: {
      neck: "",
      chest: "",
      stomach: "",
      shirttHip: "",
      shoulder: "",
      shirtLength: "",
      sleeveL: "",
      sleeveR: "",
      cuffL: "",
      cuffR: "",
      shirtSleeveLenghtL: "",
      shirtSleeveLenghtR: "",
      shortSleeveCuff: "",
    },
    jean: {
      waist: "",
      seat: "",
      thigh: "",
      frontRise: "",
      backRise: "",
      knee: "",
      bottom: "",
      outseam: "",
    },
    menOvercoat: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      overcoatLength: "",
    },
    womenJacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
    },
    womenPant: {
      waist: "",
      seat: "",
      uRise: "",
      outSeam: "",
      knee: "",
      bottom: "",
    },
    womenShort: {
      waist: "",
      seat: "",
      uRise: "",
      outSeam: "",
      knee: "",
      bottom: "",
    },
    womenVest: {
      chest: "",
      stomach: "",
      backLength: "",
      firstButton: "",
    },
    womenShirt: {
      neck: "",
      chest: "",
      stomach: "",
      shirtHip: "",
      shoulder: "",
      shirtLength: "",
      sleeveL: "",
      sleeveR: "",
      cuffL: "",
      cuffR: "",
    },
    womenOvercoat: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      overcoatLength: "",
    },
    womenJean: {
      waist: "",
      seat: "",
      thigh: "",
      frontRise: "",
      backRise: "",
      knee: "",
      bottom: "",
      outSeam: "",
    },
    palmJacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
      firstButtonPlacement: "",
    },
    bodyNotes: ["headForward"],
    fitType: "regular",
    customerNotes: "",
  });

  useEffect(() => {
    if (JsonCustomer) {
      setForm(JsonCustomer);
    }
  }, [JsonCustomer]);

  const [errors, setErrors] = useState({});
  const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];
  const countries = ["United States", "Canada"];
  const [loading, setLoading] = useState(false);
  const [messStatus, setMessStatus] = useState("");
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleChange =
    (section, key = null) =>
      (value) => {
        if (key) {
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [key]: value,
            },
          }));
        } else {
          setForm((prev) => ({ ...prev, [section]: value }));
        }
      };

  const toggleMeasurement = (key) => (value) => {
    setForm((prev) => ({
      ...prev,
      measurements: {
        ...prev.measurements,
        [key]: value,
      },
    }));
  };

  const handleChoiceChange = (key) => (value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const validate = () => {
    const newErrors = {};
    const requiredFields = [
      "name",
    ];

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    requiredFields.forEach((field) => {
      if (!form[field]) {
        newErrors[field] = "Required";
      } else {
        if (field === "email" && !emailRegex.test(form[field])) {
          newErrors[field] = "Invalid email address";
        }
      }
    });

    Object.entries(form.measurements).forEach(([key, isChecked]) => {
      if (isChecked) {
        Object.entries(form[key]).forEach(([subKey, value]) => {
          if (key === "jacket" && subKey === "firstButtonPlacement") return;
          if (key === "womenVest" && subKey === "firstButton") return;
          if (
            (key === "shirt" && subKey === "shirtSleeveLenghtL") ||
            subKey === "shirtSleeveLenghtR" ||
            subKey === "shortSleeveCuff"
          )
            return;
          if (!value) {
            if (!newErrors[key]) newErrors[key] = {};
            newErrors[key][subKey] = "Required";
          }
        });
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const adminrole = decoded.role;
    if (!token) {
      return;
    }
    setLoading(true);
    const updatedForm = {
      ...form,
      adminrole: adminrole,
    };
    fetch(`${baseUrl}/api/customers/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedForm),
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "update failed!");
        }
        setMessStatus(`The customer has been updated successfully.`);
      })
      .catch((error) => {
        setMessStatus(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const measurementLabelMap = {
    jacket: "Jacket",
    pant: "Pant",
    shortPant: "Short Pant ",
    vest: "Vest",
    shirt: "Shirt",
    jean: "Jean",
    menOvercoat: "Men Overcoat",
    womenJacket: "Women Jacket",
    womenPant: "Women Pant",
    womenShort: "Women Short",
    womenVest: "Women Vest",
    womenShirt: "Women Shirt",
    womenOvercoat: "Women Overcoat",
    womenJean: "Women Jean",
    palmJacket: "The Palm Jacket",
  };

  return (
    <AppProvider i18n={en}>
      <div className="button_option">
        <h2>
          <span onClick={handleBack}>
            <Icon source={ArrowLeftIcon} tone="base" />
          </span>{" "}
          {viewMode ? "View Customer" : "Edit Customer"}
        </h2>
      </div>
      <div className={viewMode ? "view-mode-readonly" : ""}>
      <LegacyCard title="Basic Information" sectioned>
        <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3 }} gap="400">
          <TextField
            label="Full Name"
            value={form.name}
            onChange={handleChange("name")}
            error={errors.name}
          />
          <Select
            label="Gender"
            options={["Male", "Female"]}
            onChange={handleChange("gender")}
            value={form.gender}
          />
          <TextField
            label="Email"
            value={form.email}
            onChange={handleChange("email")}
            error={errors.email}
            type="email"
          />
          <TextField
            label="Phone Number"
            value={form.phone}
            onChange={handleChange("phone")}
            error={errors.phone}
            type="number"
          />
          <TextField
            label="Address"
            value={form.address}
            onChange={handleChange("address")}
            error={errors.address}
          />
          <TextField
            label="City"
            value={form.city}
            onChange={handleChange("city")}
            error={errors.city}
          />
          <Select
            label="State"
            options={states}
            onChange={handleChange("state")}
            value={form.state}
          />
          <TextField
            label="Zip Code"
            value={form.pincode}
            onChange={handleChange("pincode")}
            error={errors.pincode}
          />
          <Select
            label="Country"
            options={countries}
            onChange={handleChange("country")}
            value={form.country}
            error={errors.country}
          />
        </InlineGrid>
      </LegacyCard>

      <LegacyCard title="Measurements" sectioned>
        <InlineGrid columns={{ xs: 3, sm: 4, md: 3, lg: 6 }} gap="300">
          {Object.keys(form.measurements).map((key) => (
            <Checkbox
              key={key}
              label={measurementLabelMap[key] || key}
              checked={form.measurements[key]}
              onChange={toggleMeasurement(key)}
            />
          ))}
        </InlineGrid>
      </LegacyCard>

      {form.measurements.jacket && (
        <JacketMeasurements
          values={form.jacket}
          errors={errors.jacket}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              jacket: { ...prev.jacket, [key]: value },
            }))
          }
        />
      )}
      {form.measurements.pant && (
        <PantMeasurements
          values={form.pant}
          errors={errors.pant}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              pant: { ...prev.pant, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.shortPant && (
        <ShortPantMeasurements
          values={form.shortPant}
          errors={errors.shortPant}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              shortPant: { ...prev.shortPant, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.vest && (
        <VestMeasurements
          values={form.vest}
          errors={errors.vest}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              vest: { ...prev.vest, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.shirt && (
        <ShirtMeasurements
          values={form.shirt}
          errors={errors.shirt}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              shirt: { ...prev.shirt, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.jean && (
        <JeanMeasurements
          values={form.jean}
          errors={errors.jean}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              jean: { ...prev.jean, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.menOvercoat && (
        <MenOvercoatMeasurements
          values={form.menOvercoat}
          errors={errors.menOvercoat}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              menOvercoat: { ...prev.menOvercoat, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.womenJacket && (
        <WomenJacketMeasurements
          values={form.womenJacket}
          errors={errors.womenJacket}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              womenJacket: { ...prev.womenJacket, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.womenPant && (
        <WomenPantMeasurements
          values={form.womenPant}
          errors={errors.womenPant}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              womenPant: { ...prev.womenPant, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.womenShort && (
        <WomenShortMeasurements
          values={form.womenShort}
          errors={errors.womenShort}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              womenShort: { ...prev.womenShort, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.womenVest && (
        <WomenVestMeasurements
          values={form.womenVest}
          errors={errors.womenVest}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              womenVest: { ...prev.womenVest, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.womenShirt && (
        <WomenShirtMeasurements
          values={form.womenShirt}
          errors={errors.womenShirt}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              womenShirt: { ...prev.womenShirt, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.womenOvercoat && (
        <WomenOvercoatMeasurements
          values={form.womenOvercoat}
          errors={errors.womenOvercoat}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              womenOvercoat: { ...prev.womenOvercoat, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.womenJean && (
        <WomenJeanMeasurements
          values={form.womenJean}
          errors={errors.womenJean}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              womenJean: { ...prev.womenJean, [key]: value },
            }))
          }
        />
      )}

      {form.measurements.palmJacket && (
        <PalmJacketMeasurements
          values={form.palmJacket}
          errors={errors.palmJacket}
          onChange={(key) => (value) =>
            setForm((prev) => ({
              ...prev,
              palmJacket: { ...prev.palmJacket, [key]: value },
            }))
          }
        />
      )}

      <div className="customer_body_option">
        <LegacyCard title="Body Notes" sectioned>
          <ChoiceList
            allowMultiple
            choices={[
              { label: "Head Forward", value: "Head Forward" },
              { label: "Left Shoulder Down", value: "Left Shoulder Down" },
              { label: "Right Shoulder Down", value: "Right Shoulder Down" },
              { label: "Left Shoulder Up", value: "Left Shoulder Up" },
              { label: "Right Shoulder Up", value: "Right Shoulder Up" },
              { label: "Humpback", value: "Humpback" },
              { label: "Arms Forward", value: "Arms Forward" },
              { label: "Arms Backward", value: "Arms Backward" },
              { label: "Chest Out", value: "Chest Out" },
              { label: "Stomach Out", value: "Stomach Out" },
              { label: "Large Bicep", value: "Large Bicep" },
              { label: "Large Calf", value: "Large Calf" },
            ]}
            selected={form.bodyNotes}
            onChange={handleChoiceChange("bodyNotes")}
          />
        </LegacyCard>
      </div>

      <LegacyCard title="Fit Type" sectioned>
        <ChoiceList
          choices={[
            { label: "Regular", value: "regular" },
            { label: "Slim", value: "slim" },
            { label: "Comfortable", value: "comfortable" },
          ]}
          selected={[form.fitType]}
          onChange={(value) => setForm({ ...form, fitType: value[0] })}
        />
      </LegacyCard>

      <LegacyCard title="NOTES" sectioned>
        <InlineGrid columns={1} gap="300">
          <div className="order_notes">
            <TextField
              value={form.customerNotes}
              onChange={handleChange("customerNotes")}
              error={errors.customerNotes}
              placeholder="Add your notes here..."
            />
          </div>
        </InlineGrid>
      </LegacyCard>

      </div>
      {messStatus && <p className="sucess_mess">{messStatus}</p>}
      {!viewMode && (
        <div className="customerAddBtn">
          {!loading ? (
            <Button variant="primary" onClick={handleSubmit}>
              Save Customer
            </Button>
          ) : (
            <Spinner accessibilityLabel="Adding customer" size="small" />
          )}
        </div>
      )}
    </AppProvider>
  );
}